import PropTypes from 'prop-types';
import WhatsAppTemplateSelector from 'src/components/whatsappComponents/WhatsAppTemplateSelector';

/* eslint-disable no-unused-vars */
const WhatsappTemplateModal = ({
    open,
    onClose,
    currentIndex,
    templates,
    onNext,
    onPrevious,
    onSend,
    onSelect,
    loading = false,
}) => {
    // Get the currently selected template based on currentIndex
    const selectedTemplate = templates?.[currentIndex] || null;

    // Handle template selection - update the index
    const handleTemplateSelect = (template) => {
        const newIndex = templates.findIndex(t => t.id === template.id);
        if (newIndex !== -1) {
            onSelect(newIndex);
        }
    };

    // Handle send
    const handleSend = (template) => {
        onSend?.(template);
    };

    return (
        <WhatsAppTemplateSelector
            open={open}
            onClose={onClose}
            templates={templates}
            selectedTemplate={selectedTemplate}
            onSelect={handleTemplateSelect}
            onSend={handleSend}
            loading={loading}
            title="Select WhatsApp Template"
        />
    );
};

export default WhatsappTemplateModal;

WhatsappTemplateModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    currentIndex: PropTypes.number.isRequired,
    templates: PropTypes.arrayOf(PropTypes.object).isRequired,
    onNext: PropTypes.func.isRequired,
    onPrevious: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired,
    onSend: PropTypes.func.isRequired,
    loading: PropTypes.bool,
};

WhatsappTemplateModal.defaultProps = {
    loading: false,
};
